/* eslint no-param-reassign: ["error", { "props": false }] */
import { layoutConfig } from '../../../container/src/formConfig';

const bg = [{
  name: 'backgroundImage',
  text: '背景图',
  type: 'upload',
  drag: true,
  onChange: async (vm, v = '', { model }) => {
    const value = v.trim();
    if (value) {
      await new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
          resolve(this);
        };
        img.src = value;
      });

      model.backgroundSize = '100% 100%';
      model.backgroundRepeat = 'no-repeat';
      model.backgroundColor = 'rgba(0, 0, 0, 0)';
    } else {
      model.backgroundColor = 'rgba(0, 0, 0, 1)';
    }
  },
}, {
  type: 'row',
  span: 12,
  items: [{
    name: 'backgroundColor',
    text: '背景颜色',
    type: 'colorPicker',
  }, {
    name: 'backgroundRepeat',
    text: '背景图重复',
    type: 'hidden',
    defaultValue: 'no-repeat',
  }],
}, {
  name: 'backgroundSize',
  text: '背景图大小',
  type: 'hidden',
}];

export default [{
  type: 'tab',
  active: '0',
  items: [{
    title: '属性',
    labelWidth: '100px',
    items: [{
      text: '名称',
      name: 'title',
    }, {
      name: 'type',
      type: 'hidden',
    }, {
      name: 'id',
      type: 'hidden',
    }, {
      name: 'name',
      type: 'hidden',
    }, {
      type: 'component',
      id: 'devConfig',
    }, layoutConfig, {
      type: 'tab',
      active: '0',
      tabType: 'border-card',
      items: [{
        title: 'tab标题默认状态',
        items: [{
          name: 'tabTitle',
          items: [{
            name: 'style',
            items: [...bg],
          }, {
            type: 'fieldset',
            text: '大小',
            labelWidth: '80px',
            name: 'style',
            items: [{
              type: 'row',
              items: [{
                name: 'width',
                text: '宽度',
              }, {
                name: 'height',
                text: '高度',
              }],
            }],
          }],
        }],
      }, {
        title: 'tab标题置灰状态',
        items: [{
          name: 'tabTitle',
          items: [{
            name: 'disabledStyle',
            items: [...bg],
          }],
        }],
      }],
    }, {
      type: 'panel',
      title: '背景样式',
      labelWidth: '100px',
      items: [{
        type: 'component',
        id: 'background',
      }],
    }],
  }],
}];
